/**
 * @file Form Controller
 */

'use strict';
import Listener from '../Utils/Listener';
import FormModel from '../Model/FormModel';

let instance = null;

/**
 * @classname Form
 * @classdesc Form Controller
 */
export default class Form {

	/**
	 * @constructor
	 */
     constructor() {
		if (instance) {
			return instance;
		}
		console.log('Form.constructor');

		this._model = new FormModel();

		this._listener = new Listener();
		this._$form = null;
		this._submit = true;

		this._model.on('uploadPhotoComplete', () => {
		    this._imageData = this._model._data;
            this._listener.trigger('uploadPhotoComplete');
        });

		instance = this;
		return instance;
	};


	/**
	 * 前処理終了
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	completePreProcessing($form) {
		if($form.attr('id') !== this._$form.attr('id')) return;
		console.log('Form.completePreProcessing');
		this._$form = $form;
		this._listener.trigger('completePreProcessing');
	};


	/**
	 * バリデーションチェック
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	validate($form) {
		if($form.attr('id') !== this._$form.attr('id')) return;
		console.log('Form.validate');
		this._$form = $form;
		this._listener.trigger('validate');
		setTimeout(() => {
			this._listener.trigger('completeValidate');
		}, 500);
	};


	/**
	 * バリデーションチェック
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	validateModal($form) {
		if($form.attr('id') !== this._$form.attr('id')) return;
		console.log('Form.validate');
		this._$form = $form;
		this._listener.trigger('validate');
	};


	/**
	 * 後処理終了
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	completePostProcessing($form) {
		if($form.attr('id') !== this._$form.attr('id')) return;
		console.log('Form.completePostProcessing');
		this._$form = $form;
		this._listener.trigger('completePostProcessing');
	};


	/**
	 * form初期化
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	initialize() {
		console.log('Form.initialize');
		this._listener.trigger('initialize');
	};


	/**
	 * パスポート情報セット
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	setPassportInfo($form, childName, cityCode, cityName, childBirthdayYY, childBirthdayMM, childBirthdayDD) {
		if(this._$form && ($form.attr('id') === this._$form.attr('id'))){
			console.log('Form.setPassportInfo');
			console.log(childName, cityCode, cityName, childBirthdayYY, childBirthdayMM, childBirthdayDD);
			const passport = JSON.stringify({
				child_name: childName,
				city_code: cityCode,
				city_name: cityName,
				child_birthday_yy: childBirthdayYY,
				child_birthday_mm: childBirthdayMM,
				child_birthday_dd: childBirthdayDD
			});
			console.log(passport);
			localStorage.setItem('passport', passport);
			setTimeout(()=> {
				this.displayPassportInfo();
			}, 400);
		}
	};

	/**
     * パスポート情報セット
     *
     * @memberof Form
     * @return {undefined}
     */
    setPassportInfo2(childName, cityCode, cityName, childBirthdayYY, childBirthdayMM, childBirthdayDD) {
        console.log('Form.setPassportInfo');
        console.log(childName, cityCode, cityName, childBirthdayYY, childBirthdayMM, childBirthdayDD);
        const passport = JSON.stringify({
            child_name: childName,
            city_code: cityCode,
            city_name: cityName,
            child_birthday_yy: childBirthdayYY,
            child_birthday_mm: childBirthdayMM,
            child_birthday_dd: childBirthdayDD
        });
        console.log(passport);
        localStorage.setItem('passport', passport);
        setTimeout(()=> {
            this.displayPassportInfo();
        }, 400);
    };


	/**
	 * パスポート情報表示
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	 displayPassportInfo() {
		console.log('Form.setPassportInfo');
		const passportFirst = JSON.parse(localStorage.getItem('passport')) || null;
		const passportList = JSON.parse(localStorage.getItem('passportList')) || null;
		if(passportFirst){
			let passport = passportFirst;
			
			if(passport['child_name']){
				$('.display-name').text(passport['child_name']);
			}else{
				$('.display-name').text('未設定');
			}
			$('.display-area').text(passport['city_name']);
			let year = parseInt(passport['child_birthday_yy']) || null;
			let month = parseInt(passport['child_birthday_mm']) || null;
			let day = parseInt(passport['child_birthday_dd']) || null;
			let age;
			console.log(year, month, day);
			if(year){
				const today = new Date();
				const birthday = new Date(year, month - 1, day);
				console.log(birthday);
				const thisYearsBirthday = new Date(today.getFullYear(), month - 1, day);
				console.log(thisYearsBirthday);
				age = today.getFullYear() - year;
				console.log(age);
				if(birthday > today){
					age = '出産前';
				}else if(today < thisYearsBirthday){
					age --;
					age = age;
				}
				if(age !== '出産前' || age !== '未設定'){
					age = age + '歳';
				}
			}else{
				age = '未設定'
			}

			if (passportList && passportList.length > 1) {
				age = age + "(※最年長 他" + (passportList.length - 1) + "名)";
				passport = passportList[0];
			}

			const city_code = passport['city_code'];
			$('.display-age').text(`${age}`);
			$('#child_name_edit').val(passport['child_name']);
			$('#city_code_edit').val(city_code);
			$('#child_birthday_yy_edit').val(passport['child_birthday_yy']);
			$('#child_birthday_mm_edit').val(passport['child_birthday_mm']);
			$('#child_birthday_dd_edit').val(passport['child_birthday_dd']);
			$('.list__item__link--city').each((idx, e) => {
				const $e = $(e);
				let href = $e.attr('href');
				href = href + `?city_code=${city_code}`;
				$e.attr('href', href);
			});
			$('.btn--search-service').each((idx, e) => {
                const $e = $(e);
                let href = $e.attr('href');
                href = href + `?city_code=${city_code}`;
                $e.attr('href', href);
            });
            $('.regist-passport-btn').addClass('off');
			$('.edit-passport-btn').removeClass('off');
            $('.regist-passport-link').addClass('off');
            $('.edit-passport-link').removeClass('off');

			this.displayPassportInfos();
        }else{
			$('.display-name').text('未設定');
			$('.display-area').text('未設定');
			$('.display-age').text('未設定');
            $('.regist-passport-btn').removeClass('off');
            $('.edit-passport-btn').addClass('off');
            $('.regist-passport-link').removeClass('off');
            $('.edit-passport-link').addClass('off');
		}
	};

	
	/**
	 * パスポート情報表示(2人目以降)
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	displayPassportInfos() {
		const passportList = JSON.parse(localStorage.getItem('passportList')) || null;
		console.log(passportList);

		let _len = getFormCountEdit();
		for (var _i=1; _i<_len; _i++) {
			delChildFormSet('form-set-edit');
		}
		if(passportList && passportList.length > 1) {
			for (var _i=1; _i<passportList.length; _i++) {
				addChildFormSet('form-set-edit', passportList[_i]);
			}
        }
	}

	/**
	 * パスポート自動削除
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	autoDeletePassportInfos() {
		const passportFirst = JSON.parse(localStorage.getItem('passport')) || null;
		let passportList = JSON.parse(localStorage.getItem('passportList')) || null;

		if (!passportList && passportFirst) {
			passportList = [];
			passportList.push(passportFirst);
		}

		if(passportList) {
			var new_passlist = [];
			var maxAge = -99;
			var default_idx = 0;
			for (var _i=0; _i<passportList.length; _i++) {
				let passport = passportList[_i];
				let year = parseInt(passport['child_birthday_yy']) || null;
				let month = parseInt(passport['child_birthday_mm']) || null;
				let day = parseInt(passport['child_birthday_dd']) || null;
				let age = 0;
				if(year){
					const today = new Date();
					const birthday = new Date(year, month - 1, day);
					age = today.getFullYear() - year;
					
  					let m = today.getMonth() - birthday.getMonth();
					// もし今年の誕生日がまだ来ていない場合、年齢から1を引く
					if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
						age--;
					}

					if (age < 18) {
						if (maxAge < age) {
							maxAge = age;
							default_idx = new_passlist.length;
						}
						new_passlist.push(passport);
					}
				}
			}
			if (new_passlist && new_passlist.length > 0) {
				localStorage.setItem('passport', JSON.stringify(new_passlist[default_idx]));
				localStorage.setItem('passportList', JSON.stringify(new_passlist));
			} else {
				localStorage.removeItem('passport');
				localStorage.removeItem('passportList');
			}
        }
	}

	/**
	 * パスポート情報表示
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	showWithdrawalModal() {
		console.log('Form.showWithdrawalModal');
		this._listener.trigger('showWithdrawal');
	}


	/**
	 * 写真アップロード
	 *
	 * @memberof Form
	 * @param {blob} file - 画像ファイル
	 * @return {undefined}
	 */
	uploadPhoto(file) {
		console.log('Form.uploadPhoto');
		this._model.uploadPhoto(file);
	};


    /**
	 * 写真削除
	 *
	 * @memberof Form
	 * @param {integer} photoId - photo ID
	 * @return {undefined}
	 */
	deletePhoto(photoId) {
		console.log('Form.deletePhoto');
		this._model.deletePhoto(photoId);
	};

	/**
	 * listener on
	 *
	 * @memberof Form
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	on(name, fn) {
		this._listener.on(name, fn);
	};


	/**
	 * listener off
	 *
	 * @memberof Form
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	off(name, fn) {
		this._listener.off(name, fn);
	};

	

	/**
	 * パスポート情報セット
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	setPassportInfos($form, passportInfoList) {
		if(this._$form && ($form.attr('id') === this._$form.attr('id'))){
			console.log('Form.setPassportInfos');
			console.log(passportInfoList);

			localStorage.setItem('passportList', JSON.stringify(passportInfoList));

			if (passportInfoList.length > 1) {
				passportInfoList.sort((a, b) => {
					if (a.child_birthday_yy !== b.child_birthday_yy) {
						return a.child_birthday_yy - b.child_birthday_yy; // 年でソート
					}
					if (a.child_birthday_mm !== b.child_birthday_mm) {
						return a.child_birthday_mm - b.child_birthday_mm; // 月でソート
					}
					return a.child_birthday_dd - b.child_birthday_dd; // 日でソート降順
				});
			}

			const passportInfo = passportInfoList[0];

			localStorage.setItem('passport', JSON.stringify(passportInfo));
			setTimeout(()=> {
				this.autoDeletePassportInfos()
				this.displayPassportInfo();
			}, 400);
		}
	};
}
